import { 
  SEND_MESSAGE_EVENT_TYPE,
  ULH_MESSAGE_RECEIVED_EVENT_TYPE,
  AIS_MESSAGE_RECEIVED_EVENT_TYPE,
  DBMANAGER_MESSAGE_RECEIVED_EVENT_TYPE,
  ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE,
  ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE,
  MAPDBVERSION_MESSAGE_RECEIVED_EVENT_TYPE,
  ONLINE_MESSAGE_CHANGE_EVENT_TYPE
 } from './utils/events'

const OFFLINE_MODE_AFTER_WEBSOCKET_CLOSE_DELAY = 3000
const PING_DELAY = 15000
const RECONNECTION_DELAY = 1000

export default function connectMessaging(url) {
  const token = localStorage.getItem('token')

  const socket = new WebSocket(url)
  let pingIntervalId = setInterval(() => socket.send('ping'), PING_DELAY)
  let offlineTimer = null

  const setOffline = () => {
    offlineTimer = setTimeout(() => {
      const event = new CustomEvent(ONLINE_MESSAGE_CHANGE_EVENT_TYPE, { detail: { online: false, action: 'timeout' } })
      document.dispatchEvent(event)
      offlineTimer = null
    }, OFFLINE_MODE_AFTER_WEBSOCKET_CLOSE_DELAY)
  }

  document.addEventListener(SEND_MESSAGE_EVENT_TYPE, (e) => {
    socket.send(JSON.stringify(e.detail))
  })

  socket.addEventListener('open', () => {
    socket.send(JSON.stringify({ jwt: token }))
  
    if (offlineTimer) {
      clearTimeout(offlineTimer)
      offlineTimer = null
    }
    const event = new CustomEvent(ONLINE_MESSAGE_CHANGE_EVENT_TYPE, { detail: { online: true, action: 'open' } })
    document.dispatchEvent(event)
  })

  socket.addEventListener('message', (e) => {
    if (e.data === 'pong') {
      const event = new CustomEvent(ONLINE_MESSAGE_CHANGE_EVENT_TYPE, { detail: { online: true, action: 'pong' } })
      document.dispatchEvent(event)
      return
    }
    try {
      const parsedMessage = JSON.parse(e.data)
      switch (parsedMessage.target) {
        case 'ulh':
          document.dispatchEvent(new CustomEvent(ULH_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage }))
          break
        case 'ais':
          const listVisibleLayers = JSON.parse(localStorage.getItem('visibleLayers'))
          if (listVisibleLayers.includes('ais')) {
            document.dispatchEvent(new CustomEvent(AIS_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage }))
          }
          break
        case 'dbm':
          document.dispatchEvent(new CustomEvent(DBMANAGER_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage }))
          break
        case 'mob':
          document.dispatchEvent(new CustomEvent(ALERT_MOB_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage }))
          break
        case 'notif':
          document.dispatchEvent(new CustomEvent(ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage }))
          break
        case 'portall':
        default:
          if (parsedMessage.dbVersion) {
            document.dispatchEvent(new CustomEvent(MAPDBVERSION_MESSAGE_RECEIVED_EVENT_TYPE, { detail: parsedMessage.dbVersion }))
          }
          break
      }
    } catch (err) {
      console.error(err)
    }
  })

  socket.addEventListener('error', () => {
    socket.close()
    setOffline()
  })

  socket.addEventListener('close', () => {
    setOffline()
    if (pingIntervalId) {
      clearInterval(pingIntervalId)
      pingIntervalId = null
    }
    setTimeout(() => {
      connectMessaging(url)
    }, RECONNECTION_DELAY)
  })

  socket.forceReconnect = () => {
    connectMessaging(url)
  }

  return socket
}